
class collectionPage {
    constructor(){
      if (performance.navigation.type == 2) {
            // window.location.reload();
      }
      this.collectionPage = document.querySelector("[collection-page]");
      let productCount = this.collectionPage.querySelectorAll("[data-product-grid]").length;
      let  filteredProductCount = this.collectionPage.querySelector("[product-count]");
      filteredProductCount = filteredProductCount.innerHTML;
      filteredProductCount = filteredProductCount.replace("Results found","");
      document.querySelector('[data-totalProducts]').innerHTML =`Showing  ${productCount} of ${filteredProductCount}`;

      if (document.querySelectorAll("[data-color-swatch-options]").length > 0 ) {
        document.querySelectorAll("[data-color-swatch-options]").forEach(ele=>{
          ele.addEventListener("click",(event)=>{
            event.preventDefault();
            this._changeSwatch(event);
          })
        })
      };
      
      if (this.collectionPage.querySelectorAll("[clear-filter]").length > 0 ) {
        this.collectionPage.querySelector("[clear-filter]").addEventListener("click",(event)=>{
          this._clearFilter(event);
        })
      };
      
    };

   
    _clearFilter(event){
      event.preventDefault();
      window.location = window.location.pathname;
    }
    
    _changeSwatch(event){
        let currentEle = event.currentTarget;
        let colorName =  currentEle.querySelector('[name="Color"]').value;
        let parentEle =  currentEle.closest("[data-product-grid]");
        let variant_json = parentEle.querySelector('[data-variantJSON]');
        let variantData =  JSON.parse(variant_json.textContent);
        variantData.forEach(ele=>{
          if (ele.title == colorName) {
            setTimeout(() => {
              parentEle.querySelector("[data-set-variant-id]").value = ele.id;
              let price = Shopify.formatMoney(ele.price, window.globalVariables.money_format);
              parentEle.querySelector("[data-currentprice]").innerHTML = price;
              parentEle.querySelector("[data-feauredimage]").srcset = ele.featured_image.src;
              parentEle.querySelector("[data-feauredimage]").src = ele.featured_image.src;
            }, 50); 
          }
        })
        parentEle.querySelectorAll("[data-color-swatch-options]").forEach(ele=>{
          let colorEle = ele.querySelector('[name="Color"]');
          colorEle.removeAttribute("checked");
        });
        let radioButton =  currentEle.querySelector('[name="Color"]');
        radioButton.setAttribute("checked","")
    };

   
}
new collectionPage()

// var csActivated = Utility.getCookie('cs-activate');
// if (csActivated == 'false' || csActivated === undefined) {
//     Utility.setCookie('cs-url', `${window.location.origin}${window.location.pathname}`, 14);
//     Utility.setCookie('cs-page', '', 14);
//     Utility.setCookie('cs-product-id', '', 14);   
// }
// window.setupContinueShoppingButton = function() {
//     var allProductGrids = document.querySelectorAll('.collection-listing-product-grid');
//     allProductGrids.forEach(item => {
//         item.addEventListener('click', (e) => {
//             var productId = item.getAttribute('data-pr-id');
//             // var pageid = item.getAttribute('data-page-id');
//             var url_string = window.location.href; 
//             var url = new URL(url_string);
//             var pageid = url.searchParams.get("page");
//             var url = window.location.href;
//             Utility.setCookie('cs-url', `${url}`, 14);
//             Utility.setCookie('cs-page', pageid, 14);
//             Utility.setCookie('cs-product-id', productId, 14);
//             console.log(productId,'productIdproductId')
//         })
//     })
// } 
// window.setupContinueShoppingButton();
// var csActivated = Utility.getCookie('cs-activate');
// if (csActivated != null && csActivated != undefined) {
//   if (csActivated != 'false') {
//     var csProductId = Utility.getCookie('cs-product-id'); 
//     console.log(csProductId,'csProductIdcsProductId')
//     if (csProductId != null || csProductId != "" || csProductId != undefined) {
//       var productEl = document.querySelector(`.collection-listing-product-grid[data-pr-id="${csProductId}"]`);
//       if (productEl != null) {
//         var scrollingHeight = 80;
//         if (window.innerWidth < 991) {
//           var headerHeight = document.querySelector('sticky-header').offsetHeight;
//           scrollingHeight = headerHeight + 80;
//         }
//         setTimeout(() => {
//           window.scrollToSmoothly((productEl.offsetTop - scrollingHeight), 100);
//         }, 2000);
//       }
//     }
//     Utility.setCookie('cs-activate', false, 14);
//   }
// }

// window.scrollToSmoothly = function(pos, time) {
//   var currentPos = window.pageYOffset;
//   var start = null;
//   if(time == null) time = 500;
//   pos = +pos, time = +time;
//   window.requestAnimationFrame(function step(currentTime) {
//       start = !start ? currentTime : start;
//       var progress = currentTime - start;
//       if (currentPos < pos) {
//           window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
//       } else {
//           window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
//       }
//       if (progress < time) {
//           window.requestAnimationFrame(step);
//       } else {
//           window.scrollTo(0, pos);
//       }
//   });
// }